import React from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from './style.module.scss'
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { getCategoryUrl } from "../../../../../../utils/url";

const ProductBreadcrumbNav = props =>{
    useStyles(classes);
    const pageProduct = useSelector((state) =>state.pageProduct);

    return <>
        {
            pageProduct?.categories?.length > 0 && <div className={classes.ProductBreadcrumbNav}>
                <a className={classes.AHref} href="/"><FormattedMessage id="home" defaultMessage="Home" /></a>
                <span className={classes.RightFont}> {'>'} </span>
                {
                    pageProduct.categories.map((item,index) =>{
                        return <span key={item.id+index} className={classes.Item}>
                            {
                                pageProduct.categories.length-1!=index?(
                                    <>
                                        <a 
                                            href={getCategoryUrl(item?.id, item?.name)}
                                            className={classes.AHref}
                                        >{item.name}</a>
                                        <span className={classes.RightFont}> {'>'} </span>
                                    </>
                                ):(
                                    <>
                                        <a 
                                            href={getCategoryUrl(item?.id, item?.name)}
                                            className={classes.AHref}
                                        ><strong>{item.name}</strong></a>
                                    </>
                                )
                            }
                        </span>
                    })
                }
            </div>
        }
    </>
    
}

export default ProductBreadcrumbNav;